<template>
	<div>
		<seccion-header />
		<seccion-banner :adviser="dataName"/>
	</div>
</template>
<script>
import seccionHeader from '@/components/advisers/seccion-header';
import seccionBanner from '@/components/advisers/section-banner';

function created() {
	if (this.nombre) {
		const nameUpper = this.nombre.toUpperCase();
		this.dataName = { ...this.advisers[nameUpper] } || {};
	}
}

function data() {
	return {
		advisers: {
			EVELYN: {
				name: 'Evelyn',
				surName: 'Diaz',
				sheetId: process.env.EMPLOYEE_1_SHEET,
				number: process.env.EMPLOYEE_1_NUMBER,
				sexo: 'F',
				day: [
					{
						id: 1,
						name: 'Lunes',
						rangeHours: [
							{
								id: 1,
								hour: '10am - 11am',
							},
							{
								id: 2,
								hour: '11am - 12pm',
							},
						],
					},
					{
						id: 2,
						name: 'Martes',
						rangeHours: [
							{
								id: 1,
								hour: '10am a 11am',
							},
							{
								id: 2,
								hour: '11am a 12pm',
							},
						],
					},
					{
						id: 3,
						name: 'Miercoles',
						rangeHours: [
							{
								id: 1,
								hour: '3pm a 4pm',
							},
							{
								id: 2,
								hour: '4pm a 5pm',
							},
						],
					},
					{
						id: 4,
						name: 'Jueves',
						rangeHours: [
							{
								id: 1,
								hour: '3pm a 4pm',
							},
							{
								id: 4,
								hour: '4pm a 5pm',
							},
						],
					},
					{
						id: 5,
						name: 'Viernes',
						rangeHours: [
							{
								id: 1,
								hour: '10am a 11am',
							},
							{
								id: 2,
								hour: '11am a 12pm',
							},
						],
					},
					{
						id: 6,
						name: 'Sabado',
						rangeHours: [
							{
								id: 1,
								hour: '9am a 10am',
							},
							{
								id: 2,
								hour: '10am a 11am',
							},
						],
					},
				],
			},
			JULIO: {
				name: 'Julio',
				surName: 'Choque',
				sheetId: process.env.EMPLOYEE_2_SHEET,
				number: process.env.EMPLOYEE_2_NUMBER,
				sexo: 'M',
			},
			KAREN: {
				name: 'Karen',
				surName: 'Zamora',
				sheetId: process.env.EMPLOYEE_3_SHEET,
				number: process.env.EMPLOYEE_3_NUMBER,
				sexo: 'F',
				day: [
					{
						id: 1,
						name: 'lunes',
						rangeHours: [
							{
								id: 1,
								hour: '4pm a 5pm',
							},
							{
								id: 2,
								hour: '5pm a 6pm',
							},
						],
					},
					{
						id: 2,
						name: 'Martes',
						rangeHours: [
							{
								id: 1,
								hour: '12pm a 1pm',
							},
							{
								id: 2,
								hour: '5pm a 6pm',
							},
						],
					},
					{
						id: 3,
						name: 'Miercoles',
						rangeHours: [
							{
								id: 1,
								hour: '12pm a 1pm',
							},
							{
								id: 2,
								hour: '5pm a 6pm',
							},
						],
					},
					{
						id: 4,
						name: 'Jueves',
						rangeHours: [
							{
								id: 1,
								hour: '11am a 12pm',
							},
							{
								id: 2,
								hour: '12pm a 1pm',
							},
						],
					},
					{
						id: 5,
						name: 'Viernes',
						rangeHours: [
							{
								id: 1,
								hour: '4pm a 5pm',
							},
							{
								id: 2,
								hour: '5pm a 6pm',
							},
						],
					},
					{
						id: 6,
						name: 'Sabado',
						rangeHours: [
							{
								id: 1,
								hour: '11am a 12pm',
							},
							{
								id: 2,
								hour: '12pm a 1pm',
							},
						],
					},
				],
			},
		},
		dataName: {},
	};
}

export default {
	name: 'page-advisers',
	data,
	created,
	components: {
		seccionHeader,
		seccionBanner,
	},
	props: {
		nombre: String,
	},
};
</script>


// WEBPACK FOOTER //
// src/pages/page-advisers.vue